import React, { Component, PropTypes } from 'react';
import gtmParts from 'react-google-tag-manager';
// import PropTypes from 'prop-types';

class GoogleTagManager extends Component {
	componentDidMount() {
		const dataLayerName = this.props.dataLayerName || 'dataLayer';
		const scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';

		if (!window[dataLayerName]) {
			const gtmScriptNode = document.getElementById(scriptId);
			// eslint-disable-next-line no-eval
			eval(gtmScriptNode.textContent);
		}
	}

	render() {
		const gtm = gtmParts({
			id: this.props.gtmId,
			dataLayerName: this.props.dataLayerName || 'dataLayer',
			additionalEvents: this.props.additionalEvents || {}
		});

		return (
			<div id="googleTagManagerContainer">
				<div>{ gtm.noScriptAsReact() }</div>
				<div id={ this.props.scriptId || 'react-google-tag-manager-gtm' }>
					{ gtm.scriptAsReact() }
				</div>
			</div>
		);
	}
}

GoogleTagManager.propTypes = {
	gtmId: PropTypes.string.isRequired,
	dataLayerName: PropTypes.string,
	additionalEvents: PropTypes.object,
	scriptId: PropTypes.string
};

export default GoogleTagManager;


// WEBPACK FOOTER //
// ./src/pages/components/GoogleTagManager.js